export enum generalParamTypes {
    TOGGLE_BIGGER1 = "TOGGLE_BIGGER_1",
    TOGGLE_BIGGER2 = "TOGGLE_BIGGER_2"
}
  
export default generalParamTypes;